import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Zustand eines Feldes der Leiste (Design-Bundle fc36ea78fc0, `PIPE_DOT`). */
export type PipeTrackStatus = 'passed' | 'failed' | 'running' | 'skipped' | 'pending';

export interface PipeTrackCell {
  status: PipeTrackStatus;
  /** Beschriftung des Feldes — Name und Zustand, fuer Tooltip und Screenreader. */
  label: string;
}

/**
 * Ein Feld je Punkt eines Pipeline-Durchlaufs — Testfall oder Job, je nachdem, woher der
 * Durchlauf kommt. Die Leiste bekommt ihre Felder fertig gerechnet: die Live-Sektion und
 * das Live-Band der Testlauf-Uebersicht (NEX-1233) leiten sie aus denselben Punkten ab —
 * dieselbe Leiste, eine Rechnung.
 */
@Component({
  selector: 'app-pipe-track',
  standalone: true,
  templateUrl: './pipe-track.component.html',
  styleUrl: './pipe-track.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PipeTrackComponent {
  readonly cells = input.required<PipeTrackCell[]>();
  readonly size = input<'sm' | 'md'>('sm');
  /** Die Leiste als Ganzes in Worten; leer laesst sie ohne eigenen Namen. */
  readonly label = input<string>('');
}
